import type { GroupedReactionDto } from "@/modules/social/gateway/socialDto"
import type { CommentEntity } from "@/modules/social/entities/socialEntity"

export type SocialCommentModel = {
  displayName: string
  creationDateLabel: string
  hasReactions: boolean
  totalReactions: number
  topReactions: GroupedReactionDto[]
  canDelete: boolean
  hasReplies: boolean
  currentUserEmoji: string | null
}

export function createSocialCommentModel(comment: CommentEntity, currentUserId: string): SocialCommentModel {
  const sortedReactions = [...comment.reactions.allGroupedReactions].sort((a, b) => b.number - a.number)

  return {
    displayName: [comment.user?.firstname, comment.user?.lastname].filter(Boolean).join(" "),
    creationDateLabel: comment.getCreationDateLabel(),
    hasReactions: comment.reactions.totalReactions > 0,
    totalReactions: comment.reactions.totalReactions,
    topReactions: sortedReactions.slice(0, 3),
    canDelete: comment.user?.id === currentUserId,
    hasReplies: comment.childrenCount > 0,
    currentUserEmoji: comment.reactions.myReaction?.emoji ?? null,
  }
}
